@if(showTable) {
<p-table [globalFilterFields]="[
            'pbm_order_id', 
            'route_name', 
            'stop_sequence', 
            'task_sequence',
            'task_point_name',
            'address',
            'postal_code',
            'delivery_point_area_name',
            'item_count',
            'goods_count',
            'task_type',
            'task_state',
            'sender_names',
            'source',
            'task_time_window'
        ]" 
        id="pTable"
        [columns]="visibleColumns"
        columnResizeMode="expand" 
        [resizableColumns]="true"
        #dataTable [value]="plannedData" 
        [selection]="taskMovementService.selectedOptionsForTaskMove"
        [rowHover]="true"
        [scrollable]="true" 
        scrollHeight="flex"
        sortMode="multiple"
        [metaKeySelection]="taskInfoService.metaKey"
        [multiSortMeta]="taskInfoService.multiSortMeta"
        [loading]="taskInfoService.loading"
        (onColResize)="saveColumnWidth($event)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="35"
        [style]="{width:'100%'}"
        dataKey="task_id"
        [customSort]="isCustomSort"
        (onSort)="onColumnSort($event)"
        [rowSelectable]="isRowSelectable"
        selectionMode="multiple" [tableStyle]="{'table-layout': 'fixed','width': '100%'}"
        (selectionChange)="onSelectionChange($event)"
        (onHeaderCheckboxToggle)="onSelectAllToggle($event)">
    <ng-template pTemplate="loadingicon">
        <svg id="ag-loading-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <circle class="circle" cx="12" cy="12" r="10" stroke-width="3" stroke="#3A5487"></circle>
            <circle class="dot" cx="21.3" cy="16" r="1.48" fill="#3A5487"></circle>
        </svg>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th style="width: 1.5rem" id="rowHighlight-header"
                [ngClass]="{'custom-sort-icon':taskInfoService.router.url != navigation.MapLeaflet, 'custom-sort-mapview':taskInfoService.router.url == navigation.MapLeaflet}">
                @if(taskMovementService.taskmoveCount()){
                <div>
                    <img [src]="sortingService.isCustomSortApplied ? customSortAppliedIconPath : customSortIconPath" (click)="setSelectedTaskSorting()"
                        class="icons-task-bank" onKeyDown="setSelectedTaskSorting()"
                        pTooltip="To sort by selected tasks" [hidden]="isSelectAll"/>
                </div>
                }
            </th>
            <th id="checkbox-header" style="width: 2.7rem; padding-left: 1.4rem;">
                @if (dataTable.filteredValue??plannedData | selectionRowAllowed) {
                    <p-tableHeaderCheckbox   />
                }
            </th>
            <th id="indicators-header" style="width: 3.5rem;">
                <i class="pi pi-flag"  pTooltip="Shipment Indicators"></i>
            </th>
            <ng-container *ngFor="let column of visibleColumns">
                <th *ngIf="column.field !== 'task_time_window'" pResizableColumn [ngStyle]="{'width': column.width}" [id]="column.field"  [pSortableColumn]="column.field">
                    {{column.label}}<p-sortIcon [field]="column.field" />
                </th>
                <th *ngIf="column.field === 'task_time_window'" pResizableColumn [ngStyle]="{'width': column.width}" [id]="column.field" pSortableColumn="task_time_window">
                    {{column.label}}<p-sortIcon field="task_time_window" />
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-plannedData let-columns="columns">
        <tr [pSelectableRowDisabled]="!plannedData.isMovementAllowed"
            [pSelectableRow]="plannedData.isMovementAllowed ? plannedData : null" [pSelectableRowIndex]="rowIndex">
            <td id="rowHighlight-header" class="custom-sort-icon"></td>
            <td class="align-items-center">
                <ng-container *ngIf="taskInfoService.router.url === navigation.MapLeaflet || taskInfoService.router.url === navigation.Landing">
                    <img [src]="plannedData.isSelectedByMap ? '../../../../../../assets/image/map_pin_selected.svg' : '../../../../../../assets/image/map_pin.svg'"
                        (click)="handleTaskClick($event, plannedData)"
                        class="map-pin-icon">
                </ng-container>
                <ng-container *ngIf="plannedData.isMovementAllowed; else showErrorMsg">
                    <p-tableCheckbox [pSelectableRow]="plannedData" [value]="plannedData"></p-tableCheckbox>
                </ng-container>
                <ng-template #showErrorMsg>
                    <i class="pi pi-info-circle info-icon p-1" [pTooltip]="taskInfoService.taskMovementErrorMsg" appendTo="body" autoHide="false" tooltipStyleClass="taskmovement-error-tooltip"></i>
                </ng-template>
            </td>
            <td class="indicator-cell">
                <div class="indicator-rail">
                    @for(indicator of plannedData?.indicators; track indicator.key; let i = $index) {
                        @if(i < 2) {
                            <img [src]="indicator.icon"
                                [pTooltip]="indicator.label"
                                tooltipPosition="bottom"
                                class="indicator-icon"
                                width="16" height="16"
                                [alt]="indicator.label" />
                        }
                    }
                    @if(plannedData?.indicators?.length > 2) {
                        <span class="indicator-overflow"
                            (click)="showIndicatorPanel($event, plannedData); $event.stopPropagation()">
                            +{{plannedData.indicators.length - 2}}
                        </span>
                    }
                </div>
            </td>

            <ng-container *ngFor="let col of visibleColumns">
                <td *ngIf="col.field !== 'address' && col.field !== 'pbm_order_id' && col.field !== 'goods_count' && col.field !== 'item_count' && col.field !== 'initial_eta' 
                && col.field !== 'eta' && col.field !== 'ata' && col.field !== 'task_state' && col.field !== 'task_time_window' && col.field !=='task_type'" class="wrapRowData"  tooltipPosition="bottom" [pTooltip]="plannedData[col.field]">
                    {{plannedData[col.field]}}
                </td>
                <td class="wrapRowData" [pTooltip]="plannedData.address" tooltipPosition="bottom" *ngIf="col.field === 'address'">
                    <ng-container *ngIf="plannedData.task_state.toLowerCase()!==taskstate.Completed; else nonEditableAddress">
                        <button (click)="taskInfoService.showDialog(plannedData, 'address', 'TaskBank'); $event.stopPropagation();"
                            class="pi pi-pencil edit-icon"></button>
                        {{plannedData.address}}
                    </ng-container>
                    <ng-template #nonEditableAddress>
                        <span style="padding-left: 1.8rem !important;">
                            {{plannedData.address}}
                        </span>
                    </ng-template>
                </td>
                <td *ngIf="col.field === 'goods_count'" (click)="openItemDialog(plannedData, 'goods'); $event.stopPropagation();"
                    [pTooltip]="plannedData.good_types" tooltipPosition="bottom"
                    onkeyDown="openItemDialog(plannedData, 'goods'); $event.stopPropagation();" [ngClass]="{'pointer-cursor': plannedData.goods_count > 0}">
                    <a *ngIf="plannedData.goods_count > 0" href="javascript:void(0)">{{plannedData.goods_count}}</a>
                    <span *ngIf="plannedData.goods_count === 0">{{plannedData.goods_count}}</span>
                </td>
                <td class="wrapRowData" [pTooltip]="plannedData.task_type" tooltipPosition="bottom" *ngIf="col.field === 'task_type'">
                    <ng-container *ngIf="plannedData.task_state.toLowerCase() !== taskstate.Completed && plannedData?.is_rp_product && (plannedData.task_type.toLowerCase() === taskType.Deliver || plannedData.task_type.toLowerCase()
                                      === taskType.Handover ) ; else nonEditableTaskType">
                        <button (click)="openStatePopup(plannedData); $event.stopPropagation();" class="pi pi-pencil edit-icon"></button>
                        {{plannedData.task_type}}
                    </ng-container>
                    <ng-template #nonEditableTaskType>
                        <span style="padding-left: 1.8rem !important;">
                            {{plannedData.task_type}}
                        </span>
                    </ng-template>
                </td>
                <td *ngIf="col.field === 'item_count'" (click)="openItemDialog(plannedData, 'items'); $event.stopPropagation();" onKeyDown="openItemDialog(plannedData, 'items'); $event.stopPropagation();"
                    [ngClass]="{'pointer-cursor': plannedData.item_count > 0}">
                    <a *ngIf="plannedData.item_count > 0" href="javascript:void(0)">{{plannedData.item_count}}</a>
                    <span *ngIf="plannedData.item_count === 0">{{plannedData.item_count}}</span>
                </td>
                <td *ngIf="col.field === 'pbm_order_id'">
                    <div class="d-flex align-items-center">
                        <!--commented out this code for future use-->
                        <!-- @if(plannedData.label_less_pickup) {
                                <img src="assets/image/label_less_pickup.png" 
                                pTooltip="Label Less Pickup" class="align-middle label-less-icon" width="13" height="13" alt="label_less_pickup" />
                        } -->
                        <ng-container *ngIf="plannedData?.pbm_order_id">
                            <i class="pi pi-search glass-icon icon" (click)="PBMlookup(plannedData.pbm_order_id);$event.stopPropagation()"
                            pTooltip="Open PBM Lookup" style="margin-right: .2rem; font-size: .6rem;"></i>
                        </ng-container>
                        <a class="anchor" href="void:()"
                         [style.--orderColor]="plannedData?.pbm_order_id | orderIdColor : plannedData?.is_rp_product : plannedData?.external_keys?.is_swedish_election_order"
                        (click)="taskInfoService.editPickupOrder(plannedData); $event.stopPropagation();">{{plannedData.pbm_order_id}}</a>
                    </div>
                </td>
                <td *ngIf="col.field === 'initial_eta'">{{plannedData.initial_eta | dateFormat : 'time'}}</td>
                <td *ngIf="col.field === 'eta'">{{plannedData.eta | dateFormat : 'time'}}</td>
                <td *ngIf="col.field === 'ata'">{{plannedData.ata | dateFormat : 'time'}}</td>
                <td *ngIf="col.field === 'task_time_window'" >{{plannedData.task_time_window}}</td>
                <td *ngIf="col.field === 'task_state'"><span [ngStyle]="plannedData.task_state | TaskState">{{plannedData.task_state}}</span></td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="visibleColumns.length + 3">
                <div class="text-center no-record-label">
                    No Records found.
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
}
<div class="taskBankSummary">
    <div>Total <b>{{plannedData.length}}</b> Tasks</div>

    @if(taskMovementService.taskmoveCount()){
        <img [src]="taskMovementService.showSelectedTaskKPI ? '../../../../../../assets/image/flip_icon_selected.svg' : '../../../../../../assets/image/flip_icon.svg'"
            (click)="taskMovementService.toggleIconRotation()"
            class="icons-task-bank"/>
    }
    
    @if(taskMovementService.taskmoveCount() && !taskMovementService.showSelectedTaskKPI){
        <div>
            <p-tag value="{{taskMovementService.taskmoveCount()}} {{taskMovementService.taskmoveCount() == 1 ? 'task' : 'tasks'}} selected" 
            class="primary-chip"/>
        </div>
        @for(kpi of taskMovementService.selectedTaskKPI; track kpi){
            @if(kpi.key==='task_type'){
            <div class="kpi-footer-props" [pTooltip]="kpi.value.toString()" tooltipPosition="top">{{kpi.key | removeUnderscore | titlecase }} : <b>{{kpi.value}}</b></div>
            }
            @else {
            <div>{{kpi.key | removeUnderscore | titlecase}} : <b>{{kpi.value}}</b>
            </div>
            }
        }
    }
    @else {
        <div><b>{{plannedTasksKpi.noOfMissedTasks}}</b> Missed</div>
        <div><b>{{plannedTasksKpi.noOfDeliveredTasks}}</b> Delivered</div>
        <div><b>{{plannedTasksKpi.noOfPickupTaskType}}</b> Pickup</div>
        <div><b>{{plannedTasksKpi.noOfPBMRequestedTasks}}</b> Requested</div>
        <div><b>{{plannedTasksKpi.noOfParcelTasks}}</b> Parcels</div>
        <div><b>{{plannedTasksKpi.noOfPalletTasks}}</b> Pallets</div>
        <div><b>{{plannedTasksKpi.noOfLetterTasks}}</b> Letters</div>
        <app-color-legends [colorlegends]="tbLegends"></app-color-legends>
    }
</div>
<p-dialog header="{{header}}" [(visible)]="displayItemDialog" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '80vw' }" [draggable]="false"
    [resizable]="false">
    <app-item-details *ngIf="displayItemDialog" (showImageDialog)="showImageDialog($event)" [additionalData]="additionalData"></app-item-details>
</p-dialog>

<app-image-gallery [displayImageDialog]="showSortingGallery" (visibleChangeUpdate)="showSortingGallery = false" [images]="sortingImage"></app-image-gallery>

@if(DialogType === 'TaskBank' && getShowPopup) {
    <p-dialog header="{{taskInfoService.updatePopup.dialogHeader}}"
    [(visible)]="getShowPopup" [modal]="true"
    (onHide)="closeDialog($event)" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">
        <app-update-address 
            (onCancel)="closeDialog($event)"
            #updateStateAddressPlanned
            [taskId]="taskInfoService.updatePopup.updateTask.task_id"
        (closeDialog)="closeDialog($event); refreshActiveTabData()"></app-update-address>
        <ng-template #footer>
            <ng-container *ngTemplateOutlet="updateStateAddressPlanned.updateAddressFooter"></ng-container>
        </ng-template>
    </p-dialog>
}

@if(stateUpdateService.showStatePopup) {
<p-dialog header="Update Task Type" [(visible)]="stateUpdateService.showStatePopup" [modal]="true" [closable]="true"
    [style]="{ width: '60vw', height: '60vh' }" (onHide)="stateUpdateService.showStatePopup = false" [appendTo]="'body'">

    <app-update-state-form #updateStateForm [tabName]="'plannedTab'" [currentTaskType]="selectedTaskType"
        (statusSubmitted)="stateUpdateService.handleTaskTypeUpdate($event, selectedTaskId)">
    </app-update-state-form>
    <ng-template #footer>
        <ng-container *ngTemplateOutlet="updateStateForm.updateStateFooter"></ng-container>
    </ng-template>
</p-dialog>
}

<p-popover #indicatorPanel [dismissable]="true" [style]="{width: '220px'}">
    <div class="indicator-panel-list">
        @for(indicator of activeIndicators; track indicator.key) {
            <div class="indicator-panel-row">
                <img [src]="indicator.icon" width="16" height="16" [alt]="indicator.label" />
                <span>{{indicator.label}}</span>
            </div>
        }
    </div>
</p-popover>